import React from 'react'
import AccountsAccounts from 'src/app/AccountsAccounts/AccountsAccounts'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountsAccountsRouteProps } from 'src/navigation/routeProps'

const AccountsAccountsAppRoute: AppRoute = {
  routeProps: accountsAccountsRouteProps,
  component: <AccountsAccounts />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountsAccountsAppRoute
